import { useState, useEffect } from 'react';
import apiUtils from 'api/apiUtils';
import useApp from 'hooks/useApp';
import Permissions from 'models/Permissions';

const useModulePermissions = (moduleName) => {
    const [permissions, setPermissions] = useState(null);
    const [error, setError] = useState(null);
    const app = useApp();
    const apiUtil = apiUtils();

    useEffect(() => {
        let jsonDefault = { module: 'N/A', cr: false, re: false, up: false, de: false };
        if (moduleName && app.auth?.user?.roleid) {
            setPermissions(jsonDefault);
            apiUtil.GetModuleAcess(moduleName, app.auth.user.roleid)
                .then((response) => {
                    if (response) {
                        setPermissions(response);
                    } else {
                        setPermissions(jsonDefault); // Return default if no response
                    }
                })
                .catch((err) => {
                    setError(err);
                    setPermissions(jsonDefault); // Return default on error
                });
        } else {
            setPermissions(jsonDefault); // Return default if moduleName or roleid is missing
        }
    }, [moduleName, app.auth?.user?.roleid]);
    return { permissions, error };
};

export default useModulePermissions;
